"use client"
import { Toaster } from 'sonner';
import { useEffect, useState } from "react";
import TemplateDetails from '../form/templatedetails';
import Preview from '../preview/preview';
import EmailTemplates from '../templates/email-templates';
import { PlateController } from '@udecode/plate/react';
import axios from 'axios';
import { validateAllFields } from '../../lib/utils';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import DialogTitle from '@mui/material/DialogTitle';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import ConfirmDeleteDialog from '../form/confirmationPopup';
import { toast } from 'react-toastify';
import { Tooltip } from '@mui/material';
import { getDefaultTemplateDetails } from '@/constants/TemplateConstants';
import TemplateEditorLayout from '../TemplateEditor/TemplateEditorLayout';

const API_URL = process.env.NEXT_PUBLIC_API_URL;
export default function Page() {
  const [selectedWord, setSelectedWord] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [getNewHTML, setGetNewHTML] = useState(false);
  const [placeholders, setPlaceholders] = useState([]);
  const [htmlMode,  setHtmlMode] = useState(false);
  const [editTemp, setEditTemp] = useState(false);
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [previewTemplateDets, setPreviewTemplateDets] = useState(false);
  const [editingTemplateId, setEditingTemplateId] = useState(null);
  const [templateDetailsData, setTemplateDetailsData] = useState(getDefaultTemplateDetails());
  const [validationErrors, setValidationErrors] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [requireWorkflowId,  setRequireWorkflowId] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [activeMode, setActiveMode] = useState<'design' | 'html' | 'preview'>('design');
  const [module, setModule] = useState('')

  const handleClose = () => {
    setOpen(false);
    setGetNewHTML(false)
  };

  const wordClicked = (word: string, fieldId: number) => {
    setSelectedWord("{{" + word + "}}");
    let allfileds = templateDetailsData.fields, stringToAdd = "";
    if (allfileds.length > 0) {
      stringToAdd = ","
    }
    stringToAdd = stringToAdd + fieldId;
    allfileds = allfileds + stringToAdd;
    updateTemplateDetails("fields", allfileds);
  }

  const showPreviewHtml = (htmlString) => {
    console.log(htmlString)
  }

  const setPlaceholdersForTemplates = (placeholderList) => {
    setPlaceholders(placeholderList);
  }

  const turnHTMLModeOff = () => {
    setHtmlMode(false);
  }

  const turnHTMLModeOn = () => {
    setHtmlMode(true)
  }

  const updateTemplateDetails = (field, data) => {
    setTemplateDetailsData(prev => ({
      ...prev,
      [field]: data,
    }));
  }

  const getCurrentHtml = () => {
      setGetNewHTML(true);
      //save template is triggered from preview component
  }

  const getCurrentHtmlForUpdate = () => {
    setGetNewHTML(true);
  }

  const handleDeleteChange = () => {
    if(selectedRows.length === 0){
      toast.info('Please select atleast 1 template!');
    }else{
      setOpenConfirmDialog(true)
    }
  }

  const handleDeleteTemplate = async () => {
    try {
      const response = await axios.post(API_URL + "templates/deleteTemplate", {
        templateIds: Array.from(selectedRows),
      });
  
      if (response.data[0]?.ErrorCode) {
        toast.error(response.data[0]?.Errormsg ?? 'Error occurred while deleting.')
      } else {
        toast.success('Templates deleted successfully.')
        const updatedTemplates = emailTemplates.filter(
          (template) => !Array.from(selectedRows).includes(template.Templateid)
        );
        setEmailTemplates(updatedTemplates);
        setSelectedRows([]); // Optional: clear selection
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error('An unexpected error occurred while deleting.')
    } finally {
      setOpenConfirmDialog(false); // Close the confirm popup
    }
  };  

  const saveTemplateDetails = (htmlString : any) => {

    const updatedData = {
      ...templateDetailsData,
      templateHtml: htmlString,
      module : templateDetailsData.module.split(',').length > 1 ? module : templateDetailsData.module
    };    
    let isValidTemplate = validateAllFields(updatedData, requireWorkflowId);
    if (isValidTemplate.length > 0) {
      setValidationErrors(isValidTemplate);
      setOpen(true);
    } else {
    setShowPreview(false);
    setGetNewHTML(false);
    if (!saving) {
      setTemplateLoading(true);
      setSaving(true);
      axios.post(API_URL + "templates/saveTemplate", updatedData).then(result => {
        console.log(result);
        setTemplateLoading(false);
        if (result.data[0]["ErrorCode"] === 0) {
          toast.success(result.data[0]["Errormsg"] || "Update successful");
          setEditTemp(false)
          setOpen(true);
          setSaving(false);
          setTemplateDetailsData(getDefaultTemplateDetails());
        }else{
          toast.error(result.data[0]["Errormsg"] || "Something went wrong");
          setOpen(true);
          setSaving(false);
        }
      })
    }
    
  }
  }

  const getTemplateToEdit = (event, template) => {
    event.preventDefault();
    event.stopPropagation();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setTemplateLoading(true); //templateLoading, 
    let requiredDetails = {
      templateId: template.Templateid,
      templateType: template.TemplateTypes,
      employerid: 10,
      tempModule: template.TempModule,
      workflowId: template.WorkflowId
    };
    axios.post(API_URL + "templates/getTemplateDetails", requiredDetails).then(result => {
      let editTempDetails = result.data;
      setEditTemp(true);
      updateGlobalData(editTempDetails, true)
      setTemplateLoading(false);
      setEditingTemplateId(editTempDetails.Templateid)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    })
  }

  const getTemplateToPreview = (event, template) => {
    event.preventDefault();
    event.stopPropagation();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setTemplateLoading(true);
    setShowTemplatePreview(true)
    let requiredDetails = {
      templateId: template.Templateid,
      templateType: template.TemplateTypes,
      employerid: 10,
      tempModule: template.TempModule,
      workflowId: template.WorkflowId
    };
    axios.post(API_URL + "templates/getTemplateDetails", requiredDetails).then(result => {
      let editTempDetails = result.data;
      setTemplateLoading(false);
      setPreviewTemplateDets(editTempDetails)
      updateGlobalData(editTempDetails, false)
      setEditTemp(true);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    })

  }

  const updateGlobalData = (editTempDetails, isEdit) => {
    const updatedData = {
      name: editTempDetails.TemplateName,
      description: editTempDetails.TemplateDescription,
      module: editTempDetails.PageModuleId.toString(),
      subject: editTempDetails.EmailSubject,
      subjectFields: editTempDetails.subjectfields,
      type: editTempDetails.TemplateType,
      fields: editTempDetails.TemplateFields,
      createdBy: 1430,
      employer: 10,
      active: "Y",
      wfNodes: editTempDetails.WorkflowNodes,
      wfId: editTempDetails.WorkflowId,
      templateHtml: editTempDetails.html,
      pageModuleId: Number(editTempDetails.Templatemodule),
    };
    if (editTemp || isEdit) {
    updatedData["templateId"] = editTempDetails["Templateid"];
    updatedData["templatePath"] = editTempDetails["TemplatePath"];
    }
    setTemplateDetailsData(updatedData)
  }

  return (
    <>
    <PlateController>
      <div className="h-screen w-full">
        <TemplateDetails 
          showTemplatePreview={showTemplatePreview} 
          setPlaceholdersForTemplates={setPlaceholdersForTemplates} 
          setRequireWorkflowId={setRequireWorkflowId} 
          updateTemplateDetails={updateTemplateDetails} 
          templateDetailsData={templateDetailsData} 
          editTemp={editTemp} 
          editingTemplateId={editingTemplateId}
          setModule={setModule}
          setTemplateDetailsData={setTemplateDetailsData}
        />
       <TemplateEditorLayout
          htmlMode={htmlMode}
          activeMode={activeMode}
          setActiveMode={setActiveMode}
          turnHTMLModeOn={turnHTMLModeOn}
          turnHTMLModeOff={turnHTMLModeOff}
          selectedWord={selectedWord}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          showPreviewHtml={showPreviewHtml}
          editTemp={editTemp}
          setTemplateDetailsData={setTemplateDetailsData}
          getCurrentHtml={getCurrentHtml}
          getCurrentHtmlForUpdate={getCurrentHtmlForUpdate}
          wordClicked={wordClicked}
          placeholders={placeholders}
          templateDetailsData={templateDetailsData}
        />
        <div className="col-span-1 gap-4 place-content-center p-2 button-wrapper list-template-grid">
          <div className='grid-header-wrapper'>
            <div className='headertext'><h5>List of Templates</h5></div>
            <div className='buttongroup'>
            <Tooltip title="Delete" arrow>
              <DeleteIcon
                fontSize="medium"
                className="deleteiocn"
                onClick={handleDeleteChange}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
            </div>
          </div>
          <EmailTemplates 
            getTemplateToEdit={getTemplateToEdit} 
            getTemplateToPreview={getTemplateToPreview} 
            setSelectedRows={setSelectedRows} 
            selectedRows={selectedRows}
            setEmailTemplates={setEmailTemplates}
            emailTemplates={emailTemplates}
          />
        </div>
        <Toaster />
        {(showPreview || getNewHTML) && <Preview closePreview={() => { setShowPreview(false) }} showPreview={showPreview} getNewHTML={getNewHTML} saveTemplateDetails={saveTemplateDetails} setTemplateDetailsData={setTemplateDetailsData}/>}
      </div>
      {validationErrors.length > 0 && <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Error while saving</DialogTitle>
        <List sx={{ pt: 0 }}>
          {validationErrors.map(validationError => {
            return <ListItem key={validationError}>
              <ListItemText primary={validationError} />
            </ListItem>
          })}
        </List>
      </Dialog>
      }
      <Modal
        open={templateLoading}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <CircularProgress className='circular-progress-icon'/>
      </Modal>
    </PlateController >
         <ConfirmDeleteDialog
         open={openConfirmDialog}
         onClose={() => setOpenConfirmDialog(false)}
         onConfirm={handleDeleteTemplate}
       />
       </>    
  );
}